import { getFileName, getFileSize, getNewFiles } from '@/utils/file'
import { getIds } from '@/utils/array'
import { putFilesSort } from '@/api/base'
import { findByKeyValue } from '@/utils/array/find'
import { showAlertError } from '@/utils/store/alert'

const createState = (fileKeys = ['files']) => {
  const filesToDelete = {}

  fileKeys.forEach(key => {
    filesToDelete[key] = []
  })

  return {
    filesToDelete,
    filesSort: {},
    // поля в которых находятся файлы сущности
    fileKeys
  }
}

const createGetters = () => ({
  countFiles: state => state.currentItem?.files?.length || 0
})

const createMutations = () => ({
  ADD_FILE_TO_DELETE: (state, { id, key = 'files' }) => {
    state.filesToDelete[key].push(id)
  },
  RESET_FILES_TO_DELETE: (state) => {
    for (const key in state.filesToDelete) {
      state.filesToDelete[key].length = 0
    }
  },
  RESET_FILES_SORT: (state) => {
    state.filesSort = {}
  }
})

const createActions = () => ({
  async processPostAndSortFiles ({ state, dispatch, commit }, { data, id }) {
    try {
      dispatch('rememberFilesSort', data)

      const response = await dispatch('checkAndPostNewFiles', { data, id })
      if (response) {
        await dispatch('setFilesSortId', response.data.data)
      }

      const sortData = await dispatch('createFilesSortData')
      if (!sortData.length) return

      await dispatch('putFilesSort', sortData)
    } catch (e) {
      showAlertError(e)
    } finally {
      commit('RESET_FILES_SORT')
    }
  },

  async checkAndPostNewFiles ({ state, dispatch }, { data, id, addExpand = true }) {
    const newFilesData = await dispatch('createNewFilesData', data)

    if (await dispatch('checkHasNewFiles', newFilesData)) {
      return await dispatch('postFilesFormData', {
        data: newFilesData,
        id,
        params: {
          expand: addExpand ? state.fileKeys.join(',') : null
        }
      })
    }
  },

  createNewFilesData ({ state }, data) {
    const newFilesData = {}

    for (const key of state.fileKeys) {
      newFilesData[key] = getNewFiles(data[key])
    }

    return newFilesData
  },

  checkHasNewFiles (_, data) {
    for (const key in data) {
      if (data[key].length) {
        return true
      }
    }
    return false
  },

  async postFilesFormData  ({ state, getters }, { data, id, params }) {
    return await state.api.postFilesFormData(id, data, params)
  },

  rememberFilesSort ({ state }, data) {
    for (const key of state.fileKeys) {
      const files = data[key]

      if (!files?.length) continue

      state.filesSort[key] = []

      files.forEach((file, i) => {
        state.filesSort[key].push({
          name: getFileName(file),
          size: getFileSize(file),
          id: file.id || null,
          sort: i
        })
      })
    }
  },

  setFilesSortId ({ state }, data) {
    for (const key in state.filesSort) {
      let fileNameKey
      if ('name' in data[key][0]) {
        fileNameKey = 'name'
      } else {
        fileNameKey = 'file_name'
      }

      for (const item of state.filesSort[key]) {
        if (item.id) continue

        const file = findByKeyValue(data[key], fileNameKey, item.name)
        if (!file) continue

        if (getFileSize(file) === item.size) {
          item.id = file.id
        }
      }
    }
  },

  createFilesSortData ({ state }) {
    const data = []
    for (const key in state.filesSort) {
      const ids = getIds(state.filesSort[key])
      data.push(ids)
    }
    return data
  },

  async putFilesSort (_, data) {
    await Promise.all(data.map(ids => putFilesSort(ids)))
  },

  async checkAndDeleteFiles ({ state, dispatch }, id) {
    if (!await dispatch('checkHasFilesToDelete')) return
    await dispatch('deleteFiles', { id, data: state.filesToDelete })
  },

  checkHasFilesToDelete ({ state }) {
    for (const key in state.filesToDelete) {
      if (state.filesToDelete[key].length) {
        return true
      }
    }
    return false
  },

  async deleteFiles ({ state, getters, commit }, { id, data }) {
    try {
      await state.api.deleteFiles(id, data)
    } catch (e) {
      console.error('ERROR ', e.message)
    } finally {
      commit('RESET_FILES_TO_DELETE')
    }
  }
})

export const vuexFileBase = {
  createState,
  createGetters,
  createMutations,
  createActions
}
